module.exports = __webpack_public_path__ + "static/media/restroom.8ba1a6ee.svg";